<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='800px')
    v-card(grid-list-md)
      v-toolbar(dark, color='primary')
        v-toolbar-title {{ $t('pageHeader.newOrganization') }}
        v-spacer
        v-btn(icon, dark, @click='close()')
          v-icon close
      v-card-text
        v-container.pa-0(grid-list-lg)          
          v-layout(row wrap)
            v-flex(xs12)
              v-text-field(autofocus v-model="Organization.organizationName" :error-messages="organizationNameErrors" label='Organization Name*')
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.ownerName" label='First Name' :error-messages="ownerNameErrors")
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.ownerLastName" label='Last Name' :error-messages="ownerLastNameErrors")
            v-flex(xs12 sm4)
              v-text-field(v-model="Organization.primaryPhone" label='Primary Phone Number' :error-messages="primaryPhoneErrors")
            v-flex(xs12 sm4)
              v-text-field(v-model="Organization.secondaryPhone" label='Secondary Phone Number')
            v-flex(xs12 sm4)
              v-text-field(v-model="Organization.textMessagePhone" label='Text Message Number' )
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.primaryEmail" label='Primary Email' :error-messages="primaryEmailErrors")
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.secondaryEmail" label='Secondary Email' :error-messages="secondaryEmailErrors")
          v-divider
          v-layout(row wrap)
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.loginEmail" label='Login Email' :error-messages="loginEmailErrors")
            v-flex(xs12 sm6)
              v-text-field(v-model="Organization.loginPassword" label='Login Password' :error-messages="loginPasswordErrors")
            
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close()') Close
        v-btn(color='blue darken-1' dark @click='save()') Save
      
</template>

<script>
import { mapGetters } from "vuex";
import organizationService from "../service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, email, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false
    }
  },
  name: "create-organization",
  data() {
    return {
      dialog: false,
      Organization: {
        organizationName: null,
        ownerName: null,
        ownerLastName: null,
        primaryPhone: null,
        secondaryPhone: null,
        primaryEmail: null,
        secondaryEmail: null,
        textMessagePhone: null,
        loginEmail: null,
        loginPassword: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Organization: {
      organizationName: {
        required,
        minLength: minLength(4)
      },
      ownerName: {
        required
      },
      ownerLastName: {
        required
      },
      primaryPhone: {
        required
      },
      primaryEmail: {
        required,
        email
      },
      secondaryEmail: {
        email
      },
      loginEmail: {
        required,
        email
      },
      loginPassword: {
        required,
        minLength: minLength(4)
      }
    }
  },
  computed: {
    organizationNameErrors() {
      const errors = [];
      if (!this.$v.Organization.organizationName.$dirty) return errors;
      if (!this.$v.Organization.organizationName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Organization.organizationName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    ownerNameErrors() {
      const errors = [];
      if (!this.$v.Organization.ownerName.$dirty) return errors;
      if (!this.$v.Organization.ownerName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    ownerLastNameErrors() {
      const errors = [];
      if (!this.$v.Organization.ownerLastName.$dirty) return errors;
      if (!this.$v.Organization.ownerLastName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    primaryPhoneErrors() {
      const errors = [];
      if (!this.$v.Organization.primaryPhone.$dirty) return errors;
      if (!this.$v.Organization.primaryPhone.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    primaryEmailErrors() {
      const errors = [];
      if (!this.$v.Organization.primaryEmail.$dirty) return errors;
      if (!this.$v.Organization.primaryEmail.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Organization.primaryEmail.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    secondaryEmailErrors() {
      const errors = [];
      if (!this.$v.Organization.secondaryEmail.$dirty) return errors;
      if (!this.$v.Organization.secondaryEmail.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    loginEmailErrors() {
      const errors = [];
      if (!this.$v.Organization.loginEmail.$dirty) return errors;
      if (!this.$v.Organization.loginEmail.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Organization.loginEmail.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    loginPasswordErrors() {
      const errors = [];
      if (!this.$v.Organization.loginPassword.$dirty) return errors;
      if (!this.$v.Organization.loginPassword.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Organization.loginPassword.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    }
  },
  methods: {
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    getActiveStore() {
      return locationService.getAll({ list: "active" }).then(result => {
        console.log("active result", result);
        result.data.map(row => {
          this.stores.push({
            id: row.storeID,
            name: row.CSPID + " - " + row.businessName
          });
        });
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Organization = {
        organizationName: null,
        ownerName: null,
        ownerLastName: null,
        primaryPhone: null,
        secondaryPhone: null,
        primaryEmail: null,
        secondaryEmail: null,
        textMessagePhone: null,
        loginEmail: null,
        loginPassword: null
      };
      this.$v.$reset;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        return organizationService
          .create(this.Organization)
          .then(result => {
            console.log("org creatred", result);
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Organization is created"
                });
              this.empty();
              this.$emit("created");
            }
          })
          .catch(err => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: err.data.data
              });
          });
      }
    }
  }
};
</script>

<style scoped></style>
